import React, { useState, useEffect } from 'react'
import { Form, Button, Row, Col } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import Loader from '../components/Loader'
import Message from '../components/Message'
import { createOuterPost } from '../actions/mediaActions'
import { OUTER_POST_CREATE_RESET } from '../constants/mediaConstants'
import { Helmet } from 'react-helmet-async'

function CreateOuterPostScreen() {
  const [title, setTitle] = useState('')
  const [description, setDescription] = useState('')
  const [image, setImage] = useState(null)

  const dispatch = useDispatch()
  const history = useHistory()

  const userLogin = useSelector(state => state.userLogin)
  const { userInfo } = userLogin

  const outerPostCreate = useSelector(state => state.outerPostCreate)
  const { loading, error, success } = outerPostCreate || {}

  // Azzera lo stato residuo di una eventuale creazione precedente: senza
  // questo, un vecchio "success: true" rimasto in Redux farebbe scattare
  // il redirect verso /forum istantaneamente, prima ancora di poter
  // scrivere qualcosa nel form.
  useEffect(() => {
    dispatch({ type: OUTER_POST_CREATE_RESET })
  }, [dispatch])

  useEffect(() => {
    if (!userInfo) {
      history.push("/login")
    }
    if (success) {
      history.push('/forum')
    }
  }, [success, history, userInfo])

  const submitHandler = (e) => {
    e.preventDefault()

    // Nickname ed email non si chiedono più nel form: si usano
    // automaticamente quelli dell'account con cui si è loggati.
    const formData = new FormData()
    formData.append('title', title)
    formData.append('nickname', userInfo.name)
    formData.append('email', userInfo.email)
    formData.append('description', description)
    if (image) {
      formData.append('image', image)
    }

    dispatch(createOuterPost(formData))
  }

  return (
    <Row className="justify-content-center">
      <Helmet>
         <meta name="robots" content="noindex, follow" />
       </Helmet>
      <Col md={6}>
        <h1 className="mt-5">Nuovo post</h1>

        {userInfo && (
          <p className="text-muted">
            Pubblichi come <strong>{userInfo.name}</strong>
          </p>
        )}

        {loading && <Loader />}
        {error && <Message variant="danger">{error}</Message>}

        <Form onSubmit={submitHandler}>
          <Form.Group controlId="title" className="my-3">
            <Form.Label>Titolo</Form.Label>
            <Form.Control
              type="text"
              placeholder="Titolo del post"
              value={title}
              required
              onChange={(e) => setTitle(e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="description" className="my-3">
            <Form.Label>Testo</Form.Label>
            <Form.Control
              as="textarea"
              rows={5}
              placeholder="Scrivi qualcosa..."
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </Form.Group>

          <Form.Group controlId="image" className="my-3">
            <Form.Label>Immagine (opzionale)</Form.Label>
            <Form.Control
              type="file"
              accept="image/*"
              onChange={(e) => setImage(e.target.files[0])}
            />
          </Form.Group>

          <Button type="submit" variant="primary" className="my-3">
            Pubblica
          </Button>
        </Form>
      </Col>
    </Row>
  )
}

export default CreateOuterPostScreen